import React from "react";
import { motion } from "framer-motion";


import useSanity from "../../customHooks/useSanity";
import { AppWrap } from "../../wrapper";
import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
	whileInView: {
		scale: [0, 1],
		opacity: [0, 1],
		transition: {
			duration: 1,
			ease: "easeInOut",
		},
	},
};

const Header = () => {
	const { profile, profileImage } = useSanity();
	

	return (
		<div className="app__header app__flex">
			<motion.div
				whileInView={{ x: [-100, 0], opacity: [0, 1] }}
				transition={{ duration: 0.5 }}
				className="app__header-info"
			>
				<div className="app__header-badge">
					<div className="badge-cmp app__flex">
						<span>👋</span>
						<div style={{ marginLeft: 20 }}>
							<p className="p-text">Hello, I am</p>
							<h1 className="head-text">
								{profile.name}
							</h1>
						</div>
					</div>

					<div className="tag-cmp app__flex">
						<p className="p-text">{profile.subtitle}</p>
						<p className="p-text">
							{profile.secondSubtitle}
						</p>
					</div>
				</div>
			</motion.div>

			<motion.div
				whileInView={{ opacity: [0, 1] }}
				transition={{ duration: 0.5, delayChildren: 0.5 }}
				className="app__header-img"
			>
				<img
					src={
						
						profileImage ? profileImage : images.profile
					}
					alt={""}
				/>
				<motion.img
					whileInView={{ scale: [0, 1] }}
					transition={{ duration: 1, ease: "easeInOut" }}
					src={images.circle}
					alt="profile_circle"
					className="overlay_circle"
				/>
			</motion.div>

			<motion.div
				variants={scaleVariants}
				whileInView={scaleVariants.whileInView}
				className="app__header-circles"
			>
				{[images.nodejs, images.devops, images.rn].map(
					(circle, index) => (
						<div
							className="circle-cmp app__flex"
							key={`circle-${index}`}
						>
							<img src={circle} alt="profile_bg" />
						</div>
					)
				)}
			</motion.div>
		</div>
	);
};

export default AppWrap(Header, "home");
